import { GqlClientService } from '@/common/network/gql-client-service'
import * as op from '../../common/errors/OperationResult'
import { type OperationResult } from '@/common/errors/OperationResult'
import { FlatCollectionTreeModel } from 'objects/gql/tree/FlatCollectionTreeModel.ts'
import type { CreateCollectionInput } from 'objects/gql/tree/CreateCollectionInput.ts'
import type { CreateFolderInput } from 'objects/gql/tree/CreateFolderInput.ts'
import type {
  CollectionModel,
  FolderModel,
  UpdateCollectionInput,
  UpdateFolderInput,
} from '@/core/gql/gql-models-override.ts'

type CreateCollectionResponse = { createCollection: CollectionModel }
type UpdateCollectionResponse = { updateCollection: CollectionModel }
type CreateFolderResponse = { createFolder: FolderModel }
type UpdateFolderResponse = { updateFolder: FolderModel }
type CollectionTreeResponse = { collectionsTree: FlatCollectionTreeModel }

export class CollectionsApiService {
  constructor(private readonly gqlClientService: GqlClientService) {}

  public async createCollection(
    input: CreateCollectionInput,
  ): Promise<OperationResult<CollectionModel>> {
    const query = `mutation($input: CreateCollectionInput!) {
  createCollection(input: $input) {
      id
      name
      typeId
      parentId
      __typename
    }
  }`

    const { result: body, error } =
      await this.gqlClientService.sendGqlRequest<CreateCollectionResponse>(query, {
        variables: {
          input,
        },
      })

    if (error) {
      return op.error(error)
    }

    return op.success(body!.data!.createCollection)
  }

  public async updateCollection(
    input: UpdateCollectionInput,
  ): Promise<OperationResult<CollectionModel>> {
    const query = `mutation($input: UpdateCollectionInput!) {
  updateCollection(input: $input) {
      id
      typeId
      name
      parentId
      __typename
  }
  }`

    const { error, result } = await this.gqlClientService.sendGqlRequest<UpdateCollectionResponse>(
      query,
      {
        variables: {
          input,
        },
      },
    )

    if (error) {
      return op.error(error)
    }

    return op.success(result!.data!.updateCollection)
  }

  public async deleteCollection(id: string): Promise<OperationResult> {
    const query = `mutation($id: ID!) {
  deleteCollection(id: $id)
  }`
    const { error } = await this.gqlClientService.sendGqlRequest<CreateFolderResponse>(query, {
      variables: {
        id,
      },
    })

    if (error) {
      return op.error(error)
    }

    return op.success()
  }

  public async createFolder(input: CreateFolderInput): Promise<OperationResult<FolderModel>> {
    const query = `mutation($input: CreateFolderInput!) {
  createFolder(input: $input) {
      id
      name
      spaceId
      parentId
      __typename
    }
  }`

    const { result: body, error } =
      await this.gqlClientService.sendGqlRequest<CreateFolderResponse>(query, {
        variables: {
          input,
        },
      })

    if (error) {
      return op.error(error)
    }

    return op.success(body!.data!.createFolder)
  }

  public async updateFolder(input: UpdateFolderInput): Promise<OperationResult<FolderModel>> {
    const query = `mutation($input: UpdateFolderInput!) {
  updateFolder(input: $input) {
      id
      spaceId
      name
      parentId
      __typename
  }
  }`

    const { error, result } = await this.gqlClientService.sendGqlRequest<UpdateFolderResponse>(
      query,
      {
        variables: {
          input,
        },
      },
    )

    if (error) {
      return op.error(error)
    }

    return op.success(result!.data!.updateFolder)
  }

  public async deleteFolder(id: string): Promise<OperationResult> {
    const query = `mutation($id: ID!) {
  deleteFolder(id: $id)
  }`
    const { error } = await this.gqlClientService.sendGqlRequest<CreateFolderResponse>(query, {
      variables: {
        id,
      },
    })

    if (error) {
      return op.error(error)
    }

    return op.success()
  }

  public async getCollectionsTree(
    spaceId: number,
    abortSignal?: AbortSignal,
  ): Promise<OperationResult<FlatCollectionTreeModel>> {
    const query = `query($spaceId: ID!) {
    collectionsTree(spaceId: $spaceId){
      nodes {
        __typename
        id
        name
        parentId
  
        ... on CollectionModel {
          typeId
        }
  
        ... on FolderModel {
          spaceId
        }
      }
      }
  }`

    // return op.success(
    //   new FlatCollectionTreeModel([
    //     new FolderModel({ id: 1, name: 'folder-root' }),
    //     new CollectionModel({ id: 2, name: 'collection-root' }),
    //     new CollectionModel({ id: 3, name: 'collection-1', parentId: 1 }),
    //     new CollectionModel({ id: 4, name: 'collection-1', parentId: 1 }),
    //     new FolderModel({ id: 5, name: 'folder-1', parentId: 1 }),
    //     new CollectionModel({ id: 6, name: 'collection-2', parentId: 5 }),
    //     new CollectionModel({ id: 7, name: 'collection-2', parentId: 5 }),
    //   ]),
    // )
    const { result: body, error } =
      await this.gqlClientService.sendGqlRequest<CollectionTreeResponse>(query, {
        variables: {
          spaceId,
        },
        abortSignal,
      })

    if (error) {
      return op.error(error)
    }
    return op.success(body!.data!.collectionsTree)
  }

  //   public async deleteSpace(id: number): Promise<OperationResult> {
  //     const mutation = `mutation($input: DeleteSpaceInput!) {
  //   deleteSpace(input: $input)
  // }`
  //     const { error } = await this.gqlClientService.sendGqlRequest<GqlResponse<unknown>>(mutation, {
  //       variables: {
  //         input: { id } as DeleteSpaceInput,
  //       },
  //     })
  //
  //     if (error) {
  //       return op.error(error)
  //     }
  //
  //     const predicate = (x: SpaceGqlModel) => x.id == id
  //     const spaces = this.types.value!.filter((x) => !predicate(x))
  //     assertLog(spaces.length == this.types.value!.length + 1, 'spaces need to be -1 after delete')
  //
  //     this.types.next(spaces)
  //     return op.success()
  //   }
}
